/**
 * Phase H10 — Assessment lifecycle status → StatusPill mapping (SA).
 *
 * Sibling of `apps/institution-admin/src/lib/assessments/statusPill.ts`.
 * SA only renders templates today (the library does not surface
 * individual questions), so we export the template mapper here.
 *
 * Pre-H10 the SA library inlined the same buggy mapping as the IA:
 * `"draft" -> "invited"`, producing an amber "Invited" pill that
 * conflicted with the staff-invite semantic. Phase H10 added a
 * canonical `"draft"` variant to `<StatusPill>` (slate hue) and this
 * helper now uses it.
 */
import type { AssessmentTemplateStatus } from "@eduviaos/shared";
import type { StatusPillStatus } from "@eduviaos/ui-kit";

export function mapTemplateStatusToPill(status: AssessmentTemplateStatus): StatusPillStatus {
  if (status === "active") return "active";
  if (status === "draft") return "draft";
  return "archived";
}
